export const isNumeric = (n: string): boolean => {
  return !isNaN(parseFloat(n)) && isFinite(Number(n))
}
